import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { initializeApp } from 'firebase/app';

const SignInSide = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const firebaseConfig = {
    apiKey: "AIzaSyCU9bXg1MFKy7Faps6lhME--JPYosPx8Yc",
    authDomain: "sunarcpowerengineers-01.firebaseapp.com",
    projectId: "sunarcpowerengineers-01",
    storageBucket: "gs://sunarcpowerengineers-01.appspot.com",
    messagingSenderId: "927443171020",
    appId: "1:927443171020:web:a08a90a30a0afbc08eb469",
    measurementId: "G-1Y4FT22JJJ",
    databaseURL: "https://sunarcpowerengineers-01-default-rtdb.asia-southeast1.firebasedatabase.app/"
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const firebaseApp = initializeApp(firebaseConfig);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const auth = getAuth(firebaseApp);

    try {
      // Sign in user with email and password
      const userCredential = await signInWithEmailAndPassword(auth, email, password);

      // Redirect to Dashboard page if login is successful
      if (userCredential && userCredential.user) {
        console.log(userCredential.user.email)
        if((userCredential.user.email) == 'sunarcpowerengineers@gmail.com'){
          navigate('/dashboard');
        }
        else{
        navigate('/marketing');
        }
      } else {
        alert('Invalid credentials. Please try again.');
      }
    } catch (error) {
      // Handle login errors
      alert('Error signing in. Please try again.');
      console.error('Error signing in:', error.message);
    }
  };


  // const handleSubmit = (event) => {
  //   event.preventDefault();

  //   // Check if email and password match
  //   if (email === 'sunarc@gmail.com' && password === '1234') {
  //     // Redirect to Dashboard page
  //     navigate('/dashboard');
  //   } else {
  //     alert('Invalid credentials. Please try again.');
  //   }
  // };

  return (
    <ThemeProvider theme={createTheme()}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: 'url(https://source.unsplash.com/random?wallpapers)',
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Sign In
              </Button>
              <Grid container>
                <Grid item xs>

                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default SignInSide;
